<template src="@/templates/account/login.html"></template>

<script>
import LoginModel from "@/models/loginModel";
import SocialMedia from "@/components/socialMedia";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import PasswordChange from "@/components/account/PasswordChange";
import PasswordReset from "@/components/account/PasswordReset";
import Disclaimer from "@/components/disclaimer/Disclaimer";
import { VueContext } from "vue-context";
import { mapActions, mapGetters } from "vuex";
import { profileInterpreterMixin } from "@/mixins/profiles/interpreter";
import {
  getUA,
  mobileModel,
  mobileVendor,
  osVersion,
  osName,
  fullBrowserVersion,
  deviceType,
  browserName,
} from "mobile-device-detect";

export default {
  name: "Login",
  props: ["passwordToken"],
  components: {
    LoginModel,
    SocialMedia,
    VueContext,
    PasswordChange,
    PasswordReset,
    Disclaimer,
  },
  data() {
    return {
      loginData: {
        user: "",
        pass: "",
        loginType: "sessional",
        staffUser: "",
      },
      loginError: false,
      popupActive: {
        show: false,
      },
      popupResetActive: {
        show: false,
      },
      token: "",
      status: "",
    };
  },
  computed: {
    ...mapGetters(["isBookingsConfirmed", "getRouteName"]),
    title() {
      return "INTERPRETER LOGIN";
    },
  },
  watch: {
    $route: "fetchData",
    isBookingsConfirmed: {
      handler: function () {
        this.fetchInterpreterProfile;
      },
      deep: true,
    },
  },
  mixins: [validationMixin, profileInterpreterMixin],
  validations: {
    loginData: {
      user: {
        required,
      },
      pass: {
        required,
      },
    },
  },
  created: function () {
    this.resetLocalStorage();
    this.fetchData();
  },

  methods: {
    ...mapActions(["updateToken", "checkJobMatchConditions"]),
    resetLocalStorage() {
      localStorage.removeItem("otp_token");
      localStorage.removeItem("mobile_last_digit");
      localStorage.removeItem("email");
      localStorage.removeItem("jwtDate");
      localStorage.removeItem("jwt");
      localStorage.removeItem("otp_delivery");
      localStorage.removeItem("mobile");
      localStorage.removeItem("userName");
    },
    fetchData() {
      if (this.isAuthenticated) {
        this.$router.push({ path: "profile" });
        return;
      }

      this.getParam("passwordToken");
      console.log(this.token);
      if (this.token != "") {
        //validate token
        this.popupActive.show = false;
        this.loginUsingPasswordToken(this.token);
      } else if (
        localStorage.getItem("jwt") == null ||
        localStorage.getItem("jwtDate") != this.getCurrentDate()
      ) {
        this.resetLocalStorage();
      }
    },

    getParam(name) {
      this.token = (location.href.split(name + "=")[1] || "").split("&")[0];
    },
    loginUsingPasswordToken() {
      this.loginModel = new LoginModel();
      this.loginModel
        .save({
          url:
            this.$interpretersApiUrl + this.loginModel.getRoute("checkToken"),
          data: {
            token: this.token,
          },
        })
        .then((res) => {
          console.log(res);
          let response = res.response.data;

          if (!response) {
            let errorMessage = "Network error. " + response.message;
            this.passwordResetError(errorMessage);
            return;
          }

          if (response.error) {
            let errorMessage = "User error. " + response.error;
            this.passwordResetError(errorMessage);
          } else {
            this.popupResetActive = true;
          }

          this.popupActive.show = false;
          this.loginData.email = "";
        });
    },
    getCurrentDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }

      today = mm + "/" + dd + "/" + yyyy;
      return today;
    },

    loginForm() {
      this.$v.$touch();
      console.log(this.$v);
      if (this.$v.$error) {
        return;
      }
      this.$vs.loading();
      this.loginModel = new LoginModel();
      this.loginModel
        .save({
          url: this.$apiAllGraduatesUrl + this.loginModel.getRoute("save"),
          data: {
            user: this.loginData.user,
            pass: this.loginData.pass,
            loginType: this.loginData.loginType,
            browser: {
              ua_type: getUA,
              os_number: osVersion,
              os: osName,
              browser_name: browserName,
              browser_version: fullBrowserVersion,
              device_type: deviceType
                ? deviceType +
                  " - vendor:" +
                  mobileVendor +
                  " - model:" +
                  mobileModel
                : "web",
            },
          },
        })
        .then((res) => {
          this.$vs.loading.close();
          console.log(res);
          let response = res.response.data;

          if (!response) {
            this.loginError = true;
            return;
          }

          if (!response.token) {
            this.loginError = true;
            return;
          }

          if (!response.two_factor_authentication) {
            localStorage.setItem("jwt", response.token);
            localStorage.removeItem("otp_token");
            /**Update jwt in store*/
            this.updateToken(response.token);

            this.fetchInterpreterProfile;
            return;
          }

          localStorage.setItem("otp_token", response.token);
          localStorage.setItem("mobile_last_digit", response.mobile);
          localStorage.setItem("email", response.email);
          localStorage.setItem("otp_delivery", response.otp_delivery);
          this.$router.push({
            path: "/authenticate",
            query: { redirect: this.$route.query.redirect },
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.error(error);
          debugger;
        });
    },
    passwordResetError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    closeChangePasswordPopUp() {
      this.popupActive.show = false;
    },
    closePasswordReset() {
      this.popupResetActive.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.form .input-container {
  padding: 30px 30px 0 30px;
}

.form h4 {
  text-transform: uppercase;
  text-align: center;
  margin-top: 50px;
  color: #4c4c4c;
}

.login h4 {
  text-transform: uppercase;
  text-align: center;
  margin-top: 20px !important;
  color: #4c4c4c;
}

.form p {
  text-transform: uppercase;
  text-align: center;
  color: #9e9e9e;
}

/*.form input {*/
/*display: block;*/
/*width: 100%;*/
/*line-height: 38px;*/
/*background-color: whitesmoke;*/
/*padding: 7px 10px;*/
/*margin-top: 20px;*/
/*border-style: hidden;*/
/*border-color: #dad6d6;*/
/*outline: none;*/
/*font-size: 20px;*/
/*}*/

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #a5a5a5;
  opacity: 1; /* Firefox */
  font-size: 16px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a5a5a5;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #a5a5a5;
}

.btn {
  width: 50%;
  height: 70px;
  bottom: 0;
  border: 0;
  font-size: 20px;
}

.btn:focus,
.btn-success:focus {
  color: white;
}

.button-group {
  positon: relative;
  background-color: transparent;
  width: 100%;
  display: flex;
  border-radius: 5px 5px 5px 5px;
}

.login-btn {
  background-color: #17b3be;
  border-radius: 0px 0px 0px 5px;
  color: white;
  transition: 0.5s;
}

.login-btn:hover {
  background-color: #018b94;
  color: white;
}

.reset-btn {
  background-color: #ed3c3a;
  border-radius: 0px 0px 5px 0px;
  color: white;
}

.reset-btn:hover {
  background-color: #c93535;
  color: white;
}

.changepassword-btn {
  background-color: #f38553;
  border-radius: 0px 0px 0px 0px;
  color: white;
}

.changepassword-btn:hover {
  background-color: #db734d;
  color: white;
}

/*@media only screen and (min-width: 576px) {*/
/*.form {*/
/*margin: 0px auto 0;*/
/*display: block;*/
/*width: 500px;*/
/*}*/

/*}*/
</style>
